export default __webpack_public_path__ + "static/media/jochen.8e9165c2.jpg";